// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-messages {\n  font-size: 16px !important;\n}\n.v-messages__message {\n  line-height: 20px !important;\n}\n.enrollment-steps div {\n  margin-left: 40px;\n}\n.v-messages__message {\n  font-size: 16px;\n}\n.v-overlay {\n  z-index: 200 !important;\n}\n.v-dialog__content {\n  z-index: 201 !important;\n}\n", ""]);
// Exports
module.exports = exports;
